import { siteAssignmentStrategies, SiteAssignmentStrategy } from "@ots-frontend/ots-data";
import { BaseDbCodeSelect, DbCodeSelectProps } from "../base-db-code-select";

type Props = DbCodeSelectProps<SiteAssignmentStrategy>;

export const SiteAssignmentStrategySelect = (props: Props) => {
  const { options = Object.values(siteAssignmentStrategies), ...rest } = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
